import React, { useEffect, useState } from "react";

import TextField from "../../Components/Commons/Forms/TextField";
import BtnSave from "../../Components/Commons/Buttons/BtnSave";
import BtnEdit from "../Commons/Buttons/BtnEdit";
import AntDTable from "../AntDTable/AntDTable";
import DateField from "../Commons/Forms/DateField";
import DeleteModal from "../Modals/DeleteModal";
import BtnDelete from "../Commons/Buttons/BtnDelete";
import InputError from "../InputError/InputError";

import { Form, Modal, Row, Col } from "react-bootstrap";
import { Upload, Button as AntDButton } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import {
  validateOthersLabResults,
} from "../Helpers/Utilities/Validations/Laboratory";
import { toast } from "react-toastify";
import {
  createMultipleLabs,
  deleteLabResult,
  getLabResults,
  updateLabResult,
} from "../Helpers/API/LabApi/LaboratoryApi";
import { formatDate, getDateToday, getRole, getUser } from "../Helpers/Utilities/Common";
import { SeeAttachment } from "./SeeAttachment";
import SelectField from "../Commons/Forms/SelectField";
import { getAllDoctors } from "../Helpers/API/DoctorApi/DoctorApi";
import imageCompression from "browser-image-compression";
import { convertImageFromUrlToFileVM5 } from "../../Utils/Common";

function Others(props) {
  const role = getRole();
  const userId = getUser();
  const [addDetails, setAddDetails] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
    lab_test_name: false,
    result_date: false,
    result: false,
    attachments: false,
  });
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [doctors, setDoctors] = useState([]);

  console.log(selectedRow);

  // Function for handling values of input fields
  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setAddDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDoctorChange = (e) => {
    setSelectedDoctor(e.id);
  };

  // Function to handle file compression and state update
  const handleBeforeUpload = async (file) => {
    let compressedFile = file;
    const fileSizeMB = file.size / 1024 / 1024;
  
    if (file.type.startsWith("image/") && fileSizeMB > 5) {
      const options = {
        maxSizeMB: 5,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };

      const compressedBlob = await imageCompression(file, options);
      // Convert the blob into a File and preserve the original name/type
      compressedFile = new File([compressedBlob], file.name, {
        type: file.type,
        lastModified: Date.now(),
      });
    }
  
    setAddDetails((prevState) => ({
      ...prevState,
      attachments: compressedFile,
    }));
    return false; // Prevent auto upload
  };

  // Function to handle file compression and state update
  const handleBeforeEditUpload = async (file) => {
    let compressedFile = file;
    const fileSizeMB = file.size / 1024 / 1024;
  
    if (file.type.startsWith("image/") && fileSizeMB > 5) {
        const options = {
          maxSizeMB: 5,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };
  
        const compressedBlob = await imageCompression(file, options);
        // Convert the blob into a File and preserve the original name/type
        compressedFile = new File([compressedBlob], file.name, {
          type: file.type,
          lastModified: Date.now(),
        });
    }
  
    setSelectedRow((prevState) => ({
      ...prevState,
      attachments: compressedFile,
    }));
    return false; // Prevent auto upload
  };

  const handleEditDoctorChange = (e) => {
    setSelectedRow((prevState) => ({
      ...prevState,
      formattedDoctor: {
        value: e.value, //doctor id
        label: e.label //doctor name
      },
    }));
    setSelectedDoctor(e.id)
  };

  // Function for handling edited values of input fields
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setSelectedRow((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function create other labs API
  const handleSave = async () => {
    setIsLoading(true);
    if (validateOthersLabResults(addDetails, setIsError)) {
      const res = await createMultipleLabs({
        patient_id: props.id,
        types: "others",
        lab_test_id: "",
        lab_result_id: "",
        selectedDate: addDetails.result_date || "",
        lab_test_name: addDetails.lab_test_name || "",
        result: addDetails.result || "",
        doctor_id: selectedDoctor || "",
        performed_by: "",
        attachments: addDetails.attachments || "",
        facility: "",
      });

      if (res.data) {
        toast.success(res.data.message);
        setAddDetails({});
        fetchOtherResults();
        props.showLabForm(false);
      } else if (res.error) {
        (res?.error?.data?.messages?.error_messages || [])?.forEach((err) => {
          toast.error(err);
        });
      }
    }
    setIsLoading(false);
  };

  // Function edit other labs API
  const handleEdit = async () => {
    setIsLoading(true);
    if (validateOthersLabResults(selectedRow, setIsError)) {
      const res = await updateLabResult(selectedRow, selectedDoctor);
      if (res.data) {
        toast.success(res.data.message);
        setSelectedRow({});
        setShowEdit(false);
        fetchOtherResults();
      } else if (res.error) {
        (res?.error?.data?.messages?.error_messages || [])?.forEach((err) => {
          toast.error(err);
        });
      }
    }
    setIsLoading(false);
  };

  // Function delete other labs API
  const handleDelete = async () => {
    setIsLoading(true);
    const res = await deleteLabResult(selectedRow.id);
    if (res.data) {
      toast.success(res.data.message);
      setSelectedRow({});
      setShowDelete(false);
      fetchOtherResults();
    } else if (res.error) {
      res.error.data.messages.error_messages.forEach((err) => {
        toast.error(err);
      });
    }
    setIsLoading(false);
  };

  // Function get other lab results API
  async function fetchOtherResults() {
    setShowLoader(true);
    const res = await getLabResults({
      lab_test_type: "others",
      patient_id: props.id,
    });
    if (res.data) {
      var _parsed = await Promise.all(
        res.data.data.map(async (radiology) => {
          const attachments = await convertImageFromUrlToFileVM5(radiology?.attachments);
          return {
            ...radiology,
            formattedDate: formatDate(radiology.result_date),
            lab_result_attachments: (
              <SeeAttachment attachments={attachments} />
            ),
            attachments: attachments,
            formattedDoctor: {
              value: radiology.doctor_id,
              label: radiology.doctor_name
            }
          };
        })
      );
      setData(_parsed);
    } else if (res.error) {
      setData([]);
    }
    setShowLoader(false);
  }

  // Function for get all doctors API
  async function fetchAllDoctors() {
    const response = await getAllDoctors();
    if (response.data) {
      var data = response.data.data.map((data, index) => {
        var info = data;
        info.label = data.doctor_name;
        info.value = data.id;
        return data;
      });
      setDoctors(data);
    } else {
      setDoctors([]);
    }
  }

  // Function for adding button in table
  function ActionBtn(row) {
    return (
      <Row className="center">
        <Col>
          <BtnSave
            id={"green-btn"}
            label={"Edit"}
            size={"sm"}
            onClick={() => {
              setShowEdit(true);
              setSelectedDoctor(row.row.doctor_id);
              setSelectedRow(row.row);
            }}
          />
        </Col>
       {
         role === "director" || role === "pcp" || role === "specialist" && (
          <>
            <Col>
              <BtnDelete
                label={"Delete"}
                size={"sm"}
                onClick={(e) => {
                  setShowDelete(true);
                  setSelectedRow(row.row);
                }}
              />
            </Col>
          </>
         )
       }
      </Row>
    );
  }

  useEffect(() => {
    fetchOtherResults();
    fetchAllDoctors();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(role === "nurse" || role === "laboratory"){
      setSelectedDoctor(null)
    } else {
      setSelectedDoctor(userId)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  return (
    <div>
      <div className="row">
        <label className="col-6 font-bold mt-2">Others Results Form</label>
      </div>
      <Row className="mt-2">
        {(role === "nurse" || role === "laboratory")  && (
          <>
            <Col style={{ zIndex: "11" }}>
              <SelectField
                required 
                searchable
                formLabel={`ATTENDING PHYSICIAN`}
                name="doctor_id" 
                size={`sm`}
                placeholder={"SELECT"}
                className="dropsearch-filter"
                options={doctors}
                onChange={(e) => handleDoctorChange(e)}
              />
              <InputError
                isValid={!selectedDoctor}
                message={"Attending Physician is required."}
              /> 
            </Col>
          </>
        )}
        <Col>
          <TextField
            required
            id={"lab_test_name"}
            name={"lab_test_name"}
            formLabel={"Laboratory/Radiology/Ultrasound"}
            size={`sm`}
            onChange={handleAddChange}
            value={addDetails.lab_test_name || ""}
            isError={isError.lab_test_name}
            errorMessage="Name is required."
          />
        </Col>
        <Col>
          <DateField
            required
            className="mt-0"
            id={"result_date"}
            name={"result_date"}
            formLabel={"Result Date"}
            size={`sm`}
            onChange={handleAddChange}
            value={addDetails.result_date || ""}
            isError={isError.result_date}
            errorMessage="Date is required."
          />
        </Col>
        <Col>
          <TextField
            // required
            id={"result"}
            name={"result"}
            formLabel={"Result"}
            size={`sm`}
            onChange={handleAddChange}
            value={addDetails.result || ""}
            isError={isError.result}
            errorMessage="Please add either result or attachment."
          />
        </Col>
        <Col>
          <p className="form-label align-left">
            Result File
          </p>
          <Upload
            accept=".pdf, image/*"
            maxCount={1}
            beforeUpload={(file) => handleBeforeUpload(file)}
            onRemove={(file) => {
              setAddDetails((prevState) => ({
                ...prevState,
                attachments: null,
              }));
            }}
          >
            <AntDButton icon={<UploadOutlined />}>Select File</AntDButton>
          </Upload>
          {/* <InputError
            isValid={!addDetails.attachments}
            message={"Attachment is required."}
          /> */}
        </Col>
      </Row>

      <Row className="justify-content-end mt-3 mb-3">
        <Col xs={2}>
          <BtnSave
            label={"Submit"}
            size={"sm"}
            onClick={handleSave}
            isClicked={isLoading}
          />
        </Col>
      </Row>

      <hr />

      <AntDTable
        tableHeaders={[
          "LAB TEST", 
          "RESULT", 
          "FILE", 
          "DATE",
          "ATTENDING PHYSICIAN"
        ]}
        headerSelector={[
          "lab_test_name",
          "result",
          "lab_result_attachments",
          "formattedDate",
          "doctor_name"
        ]}
        tableData={data}
        loading={showLoader}
        scroll={{ x: true }}
        isClickable={false}
        ActionBtn={(row) => ActionBtn(row)}
        withAction={true}
        searchExcluded={["lab_result_attachments"]}
      />

      {/* EDIT */}
      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Body>
          <div className="row">
            <Form.Label className="form-title align-center">
              Edit Result
            </Form.Label>
          </div>
          <Row>
            <TextField
              required
              id={"lab_test_name"}
              name={"lab_test_name"}
              formLabel={"Laboratory/Radiology"}
              size={`sm`}
              onChange={handleEditChange}
              value={selectedRow.lab_test_name || ""}
              isError={isError.lab_test_name}
              errorMessage="Name is required."
            />
          </Row>
          <Row>
            <DateField
              required
              className="mt-0"
              id="result_date"
              name="result_date"
              formLabel={`Result Date`}
              size={`sm`}
              onChange={handleEditChange}
              value={selectedRow.result_date || ""}
              isError={isError.result_date}
              errorMessage="Date is required."
              max={getDateToday()}
            />
          </Row>
          <Row>
            <TextField
              // required
              id={"result"}
              name={"result"}
              formLabel={"Result"}
              size={`sm`}
              onChange={handleEditChange}
              value={selectedRow.result || ""}
              // isError={isError.result}
              // errorMessage="Result is required."
            />
          </Row>
          {(role === "nurse" || role === "laboratory")  && (
            <>
              <div className="row" style={{ zIndex: "11" }}>
                <SelectField
                    required 
                    searchable
                    formLabel={`Attending Physician`}
                    name="doctor_id" 
                    size={`sm`}
                    placeholder={"SELECT"}
                    className="dropsearch-filter"
                    value={selectedRow.formattedDoctor}
                    options={doctors}
                    onChange={(e) => handleEditDoctorChange(e)}
                  />
              </div>
            </>
          )}
          <Row>
            <p className="form-label align-left">
              Result File
            </p>
            <Upload
              accept=".pdf, image/*"
              maxCount={1}
              defaultFileList={
                selectedRow?.attachments
                  ? 
                    [
                      ...(selectedRow?.attachments?.map((attachment) => ({
                        url: attachment?.file_url || "",
                        name: attachment?.file_name || "",
                        status: "done",
                      })))
                    ]
                  : []
              }
              beforeUpload={(file) => handleBeforeEditUpload(file)}
              onRemove={(file) => {
                setSelectedRow((prevState) => ({
                  ...prevState,
                  attachments: null,
                }));
              }}
            >
              <AntDButton icon={<UploadOutlined />}>Select File</AntDButton>
            </Upload>
            {/* <InputError
              isValid={!selectedRow.attachments}
              message={"Attachment is required."}
            /> */}
          </Row>
          <Row className="mt-4">
            <Col>
              <BtnDelete
                label="Close"
                onClick={() => setShowEdit(false)}
                isClicked={isLoading}
              />
            </Col>
            <Col>
              <BtnEdit
                disabled={
                  !selectedRow.result_date || 
                  (!selectedRow.attachments && !selectedRow.result)
                }
                label="Save changes"
                onClick={handleEdit}
                isClicked={isLoading}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      {/* DELETE */}
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onDelete={handleDelete}
        title={`Are you sure you want to delete this result?`}
      />
    </div>
  );
}

export default Others;
